<!-- Ported from the Polaris kit: src/components/ui/checkbox/Checkbox.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { Checkmark16 as Check } from '@carbon/icons-vue';
import { reactiveOmit } from '@vueuse/core';
import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  defaultValue: { type: null, required: false },
  modelValue: { type: null, required: false },
  disabled: { type: Boolean, required: false },
  value: { type: null, required: false },
  id: { type: String, required: false },
  trueValue: { type: null, required: false },
  falseValue: { type: null, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  name: { type: String, required: false },
  required: { type: Boolean, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
const emits = defineEmits(['update:modelValue']);

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <CheckboxRoot
    v-slot="slotProps"
    data-slot="checkbox"
    v-bind="forwarded"
    :class="
      cn(
        'peer border-polaris-input data-[state=checked]:bg-polaris-primary data-[state=checked]:text-polaris-primary-foreground data-[state=checked]:border-polaris-primary focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 aria-invalid:ring-polaris-destructive/20 dark:aria-invalid:ring-polaris-destructive/40 aria-invalid:border-polaris-destructive size-4 shrink-0 rounded-[4px] border border-solid shadow transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 p-0',
        props.class
      )
    "
  >
    <CheckboxIndicator
      data-slot="checkbox-indicator"
      class="grid place-content-center text-current transition-none"
    >
      <slot v-bind="slotProps">
        <Check class="size-3.5 p-0" />
      </slot>
    </CheckboxIndicator>
  </CheckboxRoot>
</template>
